<template>
  <div class="pricingContainer">
    <div class="description">
      <p class="title">Pricing</p>
      <p class="descriptionContent">Description of product feature in concise manner that wraps to the third line if needed.</p>
    </div>
    <hr color="#E5E5E5" size="1" width="1212px"/>
    <div class="priceList">
      <div class="individual">
        <p class="title">Individual</p>
        <p class="role">For individual translators</p>
        <p class="priceValue"><i>$</i><span>0</span></p>
        <p class="billingMethod">Free forever</p>
        <el-button :plain="true" @click.native="getStart()" >GET STARTED</el-button>
        <hr color="#E5E5E5" size="1" width="224px"/>
        <div class="individualFeatureAndDescription">
          <ul>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li class="learnmorn">Learn more</li>
          </ul>
        </div>
      </div>
      <div class="team pricegroup">
        <p class="title">Team</p>
        <p class="role">For teams in your organization</p>
        <p class="priceValue"><i>$</i><span>12</span></p>
        <p class="billingMethod">Per member, per month billed annually</p>
        <el-button :plain="true" @click.native="getStart()" >GET STARTED</el-button>
        <hr color="#E5E5E5" size="1" width="224px"/>
      
        <div class="team pricegroup individualFeatureAndDescription">
          <ul>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li class="learnmorn">Learn more</li>
          </ul>
        </div>
      </div>
      <div class="enterprise pricegroup">
        <p class="title">Enterprise</p>
        <p class="role">For your entire organization</p>
        <p class="priceValue"><i>$</i><span>24</span></p>
        <p class="billingMethod">Per member, per month billed annually</p>
        <el-button :plain="true" @click.native="getStart()" >GET STARTED</el-button>
        <hr color="#E5E5E5" size="1" width="224px"/>
        <div class="enterprise pricegroup individualFeatureAndDescription">
          <ul>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li><i class="el-icon-check"></i>Feature and description</li>
            <li class="learnmorn">Learn more</li>
          </ul>
        </div>
      </div>
    </div> 
   <!--  <hr color="#E5E5E5" size="1" width="1212px"/>
    <div class="featureAndDescription">
      <div class="individual">
        <ul>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li class="learnmorn">Learn more</li>
        </ul>
      </div>
      <div class="team pricegroup">
        <ul>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li class="learnmorn">Learn more</li>
        </ul>
      </div>
      <div class="enterprise pricegroup">
        <ul>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li><i class="el-icon-check"></i>Feature and description</li>
          <li class="learnmorn">Learn more</li>
        </ul>
      </div>
    </div> -->
    <div class="comparePlans">
      <p class="title">Compare Plans</p>
      <p class="compareContent">Description of product feature in concise manner that wraps to the second line if needed.</p>
    </div>
    <div class="questions">
      <p class="title">Frequently Asked Questions</p>
      <p class="question">Questions about the product?<i class="el-icon-arrow-down"></i></p>
      <p class="question">Questions about the product?<i class="el-icon-arrow-down"></i></p>
      <p class="question">Questions about the product?<i class="el-icon-arrow-down"></i></p>
      <p class="question">Questions about the product?<i class="el-icon-arrow-down"></i></p>
      <p class="question">Questions about the product?<i class="el-icon-arrow-down"></i></p>
      <p class="question">Questions about the product?<i class="el-icon-arrow-down"></i></p>
      <p class="question">Questions about the product?<i class="el-icon-arrow-down"></i></p>
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.pricingContainer{
    padding: 0;
    margin-top:40px;
    text-align:center;
    padding-bottom:80px;
}
.pricingContainer hr{margin:0 auto;}
.pricingContainer .description{
  height:303px;
  padding-top:86px;
}
.pricingContainer .description .title{
  width: 100%;
  height: 59px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  color: #000000;
}
.pricingContainer .description .descriptionContent{
  max-width: 714px;
  height: 77px;
  margin-top: 26px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  color: #000000;
  margin:0 auto;
  width: 100%;
  padding: 0 10px;
}
.pricingContainer .priceList{
  padding-top:64px;
  padding-bottom:24px;
  height: auto;
}
.pricingContainer .priceList div{
  width: 224px;
  /*height: 423px;*/
  display:inline-block;
}
.pricingContainer .priceList .pricegroup{
  vertical-align:bottom;
}
.pricingContainer .priceList .team{
  width:614px;
  /*padding:0 195px;*/
}
.pricingContainer .priceList .title{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 39px;
  color: #000000;
}
.pricingContainer .priceList .role{
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  margin-top:29px;
  color: #646464;
  height: 44px;
}
.pricingContainer .priceList .priceValue{
  width:150px;
  height:83px;
  margin:0 auto;
  margin-top:48px;
}
.pricingContainer .priceList .priceValue i{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 76px;
  color: #000000;
  margin: 0px 12px 0 0;
  display:inline-block;
  vertical-align:bottom;
  height:76px;
}
.pricingContainer .priceList .priceValue span{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 68px;
  line-height: 83px;
  color: #000000;
  margin: 0;
  display:inline-block;
  vertical-align:bottom;
}
.pricingContainer .priceList .billingMethod{
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.03em;
  color: #000000;
  margin-top:10px;
  height:30px;
}
.pricingContainer .priceList .el-button{
  padding: 16px 24px;
  border: 1px solid #222222;
  box-sizing: border-box;
  border-radius: 10px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
  color: #000000;
  margin-top:40px;
  margin-bottom: 40px;
}
.pricingContainer .featureAndDescription .el-button:hover{
  background: #222222;
  color:#ffffff;
}
.pricingContainer .featureAndDescription div{
  width: 271px;
  height: 423px;
  display:inline-block;
}
.pricingContainer .featureAndDescription .pricegroup{
  vertical-align:bottom;
}
.pricingContainer .featureAndDescription .team{
  width:567px;
  padding:0 148px;
}
.pricingContainer .featureAndDescription ul li{
  width: 271px;
  height: 22px;
  margin-top:32px;
}
.pricingContainer .featureAndDescription ul li i{
  color: #6FCF97;
  font-size:17px;
  margin-right:32px;
  vertical-align: middle;
  font-weight: bold;
}
.pricingContainer .featureAndDescription .learnmorn{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  text-decoration-line: underline;
  color: #222222;
  margin-top:38px;
}
.pricingContainer .comparePlans{
  height: 2229px;
  background: #F8F8F8;
  padding-top:108px;
}
.pricingContainer .comparePlans .title{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  text-align: center;
  color: #000000;
}
.pricingContainer .comparePlans .compareContent{
  max-width: 714px;
  height: 77px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  margin-top:26px;
  color: #000000;
  display:inline-block;
  width: 100%;
  padding: 0 10px;
}
.pricingContainer .questions{
  padding-top:132px;
}
.pricingContainer .questions .title{
  max-width: 707px;
  height: 59px;
  left: 114px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  color: #000000;
  text-align:left;
  margin-bottom:79px;
  width: 100%;
}
.pricingContainer .questions .question{
  left: 114px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 32px;
  color: #000000;
  text-align:left;
  width: calc(100% - 228px);
  height: 80px;
  line-height: 80px;
  border-top: 0.5px solid #D5D5D5;
}
.pricingContainer .questions .question i{float:right;margin-top: 24px;color: #AFAFAF;}
/*.pricingContainer .priceList .el-row{
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  display: inline-block;
}
.pricingContainer .priceList .el-row .el-col{
  max-width: 224px;
  width: 100%;
  display: inline-block;
  padding-bottom: 40px;
}*/
@media only screen and (max-width: 1200px){
  .pricingContainer .priceList .team{
    width: 224px !important;
    padding: 0px !important;
    margin: 0 7%;
  }
  .pricingContainer .featureAndDescription .team{
    width: 271px !important;
    padding: 0px !important;
    margin: 0 3%;
  }
}
@media only screen and (max-width: 790px){
  .pricingContainer .questions .title{
    height: auto !important;
    left: 0 !important;
    text-align: center !important;
  }
  .pricingContainer .questions .question{
    font-size: 18px !important;
    width: calc(100% - 60px);
    left: 30px;
  }
}
.pricingContainer .individualFeatureAndDescription .el-button:hover{
  background: #222222;
  color:#ffffff;
}
.pricingContainer .individualFeatureAndDescription{
  width: 271px;
  height: 423px;
  display:inline-block;
}
.pricingContainer .individualFeatureAndDescription .pricegroup{
  vertical-align:bottom;
}
.pricingContainer .individualFeatureAndDescription ul li{
  /*width: 271px;*/
  height: 22px;
  margin-top:32px;
}
.pricingContainer .individualFeatureAndDescription ul li i{
  color: #6FCF97;
  font-size:17px;
  margin-right:32px;
  vertical-align: middle;
  font-weight: bold;
}
.pricingContainer .individualFeatureAndDescription .learnmorn{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  text-decoration-line: underline;
  color: #222222;
  margin-top:38px;
}
</style>




// WEBPACK FOOTER //
// src/components/Pricing.vue